import React from "react";

import { TemplateName } from "../../../../../../types/templates/template-name";

import { CbTemplateViewProps } from "../../../../types/cb-template-view/cb-template-view.props";

import { CbTemplateControlAdditionalDetails } from "../../../cb-template-control/components/cb-template-control-additional-details/cb-template-control-additional-details.component";
import { CbTemplateControlCampaignOverview } from "../../../cb-template-control/components/cb-template-control-campaign-overview/cb-template-control-campaign-overview.component";
import { CbTemplateControlContext } from "../../../cb-template-control/components/cb-template-control-context/cb-template-control-context.component";
import { CbTemplateControlLegalRequirements } from "../../../cb-template-control/components/cb-template-control-legal-requirements/cb-template-control-legal-requirements.component";
import { CbTemplateControlStartEndDate } from "../../../cb-template-control/components/cb-template-control-start-end-date/cb-template-control-start-end-date.component";
import { CbTemplateLayout } from "../../../cb-template-layout/components/cb-template-layout/cb-template-layout.component";
import { CbTemplateLayoutLeft } from "../../../cb-template-layout/components/cb-template-layout-left/cb-template-layout-left.component";
import { createCbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control-props.functions";

import { CbTemplateStandardRightSection } from "../cb-template-standard-right-section/cb-template-standard-right-section.component";

export const CbTemplateSimpleSingleAsset = (props: CbTemplateViewProps) => {
  const controlProps = createCbTemplateControlProps(props);
  return (
    <CbTemplateLayout ndaData={props.ndaData}>
      <CbTemplateLayoutLeft>
        <CbTemplateControlCampaignOverview
          subTitle={TemplateName.CampaignBrief.SimpleSingleAsset}
          {...controlProps}
        />
        <CbTemplateControlStartEndDate {...controlProps} />
        <CbTemplateControlContext {...controlProps} />
        <CbTemplateControlAdditionalDetails {...controlProps} />
        <CbTemplateControlLegalRequirements {...controlProps} />
      </CbTemplateLayoutLeft>
      <CbTemplateStandardRightSection {...props} marketingChannelsIsRequired={false} />
    </CbTemplateLayout>
  );
};
